export const SYMBOLS = [
    '◇', 
    '◆',  
    '❖', 
    '◈', 
    '⬖', 
    '⛋', 
    '⟐', 
    '⧪', 
    '⍚', 
    '⧰', 
    '⧱',
    '⨀',
    '⨁',
    '⨂',
    '⚠',
    '☡',
    '⛖',
    '⛗',
    '⛒',
    '⛐',
    '⛍',
    '⛛',
    '⛡',
    '⛌',
    '⛕',
    '⛚',
    '⛘',
    '☀',
    '☼',
    '❂',
    '☉',
    '☽',
    '☾',
    '☁',
    '⛆',
    '❅',
    '❄',
    '❆',
    '☃',
    '⛇',
    '☇',
    '☈',
    '☿',
    '♀',
    '♁',
    '⊕',
    '♂',
    '♃',
    '♄',
    '♅',
    '$',
    '¢',
    '£',
    '¤',
    '¥',
    '₿',
    '₩',
    '₡',
    '₤',
    '₪',
    '₳',
    '฿',
    '₢',
    '₫',
    '₣',
    '₹',
    '₠',
]